import React, { useState } from 'react'
import TextInput from './elements/TextInput'

import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'

// Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

export default function Group({ guestData, setGuestData }) {
	const [swiper, setSwiper] = useState(null)
	const [activeIndex, setActiveIndex] = useState(0) // Add this state

	const onValueChange = (idx, name, value) => {
		const updatedData = guestData.map((data, index) => {
			if (index === idx) return { ...data, [name]: value }
			else return data
		})

		setGuestData(updatedData)
	}

	// const handleAddNewGuest = () => {
	// 	setGuestData((prev) => [
	// 		...prev,
	// 		{
	// 			name: '',
	// 			gender: '',
	// 			contact: '',
	// 			email: '',
	// 		},
	// 	])
	// 	setTimeout(() => {
	// 		swiper.slideTo(guestData.length + 1)
	// 	}, 200)
	// }

	const handleDeleteGuest = (idx) => {
		if (guestData.length <= 1) return
		const updatedData = guestData.filter((g, i) => i !== idx)
		setGuestData(updatedData)
	}

	return (
		<div>
			{/* Guest Card */}
			<div className="p-2">
				<Swiper
					spaceBetween={16}
					slidesPerView={1}
					onSwiper={setSwiper}
					onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)} // Add this handler
					modules={[Pagination, Navigation]}
					pagination={{
						el: '.swiper-custom-pagination',
						clickable: true,
					}}
					navigation={{
						prevEl: 'swiper-prev-button',
						nextEl: 'swiper-next-button',
					}}
					grabCursor
				>
					{guestData.map((guest, idx) => {
						return (
							<SwiperSlide>
								<div className="w-full bg-white p-5 shadow rounded-xl ">
									<GuestSlide
										idx={idx}
										data={guest}
										onValueChange={onValueChange}
										deleteGuestFunc={handleDeleteGuest}
										disableDeleteBtn={guestData.length <= 2}
									/>
								</div>
							</SwiperSlide>
						)
					})}
				</Swiper>
			</div>

			{/* Swiper Custom Navigation and Pagination */}
			<div
				className={`flex items-center gap-4 text-center justify-between py-2 px-4 ${
					guestData.length <= 1 && 'hidden'
				}`}
			>
				<div className="swiper-prev-button">
					<button
						className="group py-1 px-2 rounded-md bg-gray-200 hover:bg-primary  group-hover:scale-105 transition-all disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-gray-200"
						title="Previous"
						onClick={() => swiper.slidePrev()}
					>
						<svg
							className=" w-4 group-hover:fill-white group-disabled:group-hover:fill-inherit h-auto transition-all"
							fill="#000000"
							viewBox="0 0 32 32"
							style={{
								fillRule: 'evenodd',
								clipRule: 'evenodd',
								strokeLinejoin: 'round',
								strokeMiterlimit: 2,
							}}
							version="1.1"
							xmlSpace="preserve"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsSerif="http://www.serif.com/"
							xmlnsXlink="http://www.w3.org/1999/xlink"
						>
							<path d="M6.507,17.508l20.963,-0.008c0.828,-0 1.5,-0.673 1.5,-1.501c-0.001,-0.827 -0.673,-1.499 -1.501,-1.499l-20.975,0.008c0.088,-0.119 0.188,-0.231 0.298,-0.334c0,0 9.705,-9.079 9.705,-9.079c0.605,-0.565 0.636,-1.515 0.071,-2.12c-0.566,-0.604 -1.516,-0.636 -2.12,-0.07c-0,-0 -5.9,5.519 -9.705,9.078c-1.118,1.045 -1.749,2.509 -1.743,4.038c0.006,1.53 0.649,2.989 1.774,4.025c3.848,3.543 9.829,9.05 9.829,9.05c0.609,0.56 1.559,0.521 2.119,-0.088c0.561,-0.609 0.522,-1.558 -0.087,-2.119c-0,-0 -5.98,-5.507 -9.828,-9.05c-0.111,-0.102 -0.211,-0.213 -0.3,-0.331Z" />
						</svg>
					</button>
				</div>

				<div className="flex flex-col items-center">
					<div className="swiper-custom-pagination" />
					<small className="font-semibold">
						{activeIndex + 1} / {guestData.length}
					</small>
				</div>

				<div className="swiper-next-button">
					<button
						className="group py-1 px-2 rounded-md bg-gray-200 hover:bg-primary  group-hover:scale-105 transition-all"
						title="Next"
						onClick={() => swiper.slideNext()}
					>
						<svg
							fill="#000000"
							className=" w-4 group-hover:fill-white h-auto transition-all"
							viewBox="0 0 32 32"
							style={{
								fillRule: 'evenodd',
								clipRule: 'evenodd',
								strokeLinejoin: 'round',
								strokeMiterlimit: 2,
							}}
							version="1.1"
							xmlSpace="preserve"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsSerif="http://www.serif.com/"
							xmlnsXlink="http://www.w3.org/1999/xlink"
						>
							<path d="M25.468,14.508l-20.967,-0.008c-0.828,-0 -1.501,0.672 -1.501,1.499c-0,0.828 0.672,1.501 1.499,1.501l21.125,0.009c-0.107,0.159 -0.234,0.306 -0.377,0.439c-3.787,3.502 -9.68,8.951 -9.68,8.951c-0.608,0.562 -0.645,1.511 -0.083,2.119c0.562,0.608 1.512,0.645 2.12,0.083c-0,0 5.892,-5.448 9.68,-8.95c1.112,-1.029 1.751,-2.47 1.766,-3.985c0.014,-1.515 -0.596,-2.968 -1.688,-4.018l-9.591,-9.221c-0.596,-0.574 -1.547,-0.556 -2.121,0.041c-0.573,0.597 -0.555,1.547 0.042,2.121l9.591,9.221c0.065,0.063 0.127,0.129 0.185,0.198Z" />
						</svg>
					</button>
				</div>
			</div>
		</div>
	)
}

const GuestSlide = ({ idx, data, onValueChange, deleteGuestFunc, disableDeleteBtn }) => {
	return (
		<div className="space-y-3 w-full">
			<div className="flex items-center justify-between">
				<h5 className="font-bold text-black text-[20px] mb-4">Guest {idx + 1}</h5>
				{/* <button
					title="Delete"
					className={`p-1 rounded-full bg-gray-100 hover:bg-gray-200 hover:scale-105 transition-all duration-300 ${
						disableDeleteBtn &&
						'opacity-70 hover:scale-100 hover:bg-inherit hover:cursor-not-allowed'
					}`}
					onClick={() => !disableDeleteBtn && deleteGuestFunc(idx)}
				>
					<svg
						className="w-5 h-auto"
						width="64px"
						height="64px"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g id="SVGRepo_iconCarrier">
							<path
								d="M10 12V17"
								stroke="#222"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M14 12V17"
								stroke="#222"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M4 7H20"
								stroke="#222"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10"
								stroke="#222"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
								stroke="#222"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</g>
					</svg>
				</button> */}
			</div>

			{/* Name Field */}
			<TextInput
				label={'Name*'}
				placeholder={'Enter Your Name'}
				type={'text'}
				name="name"
				value={data?.name}
				onChange={(e) => onValueChange(idx, e.target.name, e.target.value)}
			/>

			{/* Gender Selection */}
			<div>
				<label className="text-[#666666]">{'Gender'}*</label>
				<div className="flex space-x-2 mt-2">
					{['Male', 'Female', 'Other'].map((gender) => (
						<button
							key={gender}
							name="gender"
							value={gender}
							onClick={(e) => onValueChange(idx, e.target.name, e.target.value)}
							className={`py-2 px-4 rounded-md ${
								data?.gender === gender
									? 'bg-primary text-white'
									: ' bg-transparent border-2 border-[#ccc] text-black'
							}`}
						>
							{gender}
						</button>
					))}
				</div>
			</div>

			{/* Contact Field */}
			<TextInput
				label={'Contact*'}
				placeholder={'Enter Your Mobile Number'}
				type={'tel'}
				name="contact"
				value={data?.contact}
				onChange={(e) => onValueChange(idx, e.target.name, e.target.value)}
			/>

			{/* Email Field */}
			<TextInput
				label={'Email'}
				placeholder={'Enter Your Email ID'}
				type={'email'}
				name="email"
				value={data?.email}
				onChange={(e) => onValueChange(idx, e.target.name, e.target.value)}
			/>
		</div>
	)
}
